var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-header"},[_c('div',{staticClass:"title"},[_vm._v("Energy Planning Process")]),_c('plan-description'),(!_vm.noSteps)?_c('steps',{attrs:{"step":_vm.step},on:{"select-index":_vm.handleStepSelection}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }